import React from 'react';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const SimulationNeedsLayout = ({ children }) => {
  return <PageLayout>{children}</PageLayout>;
};

export default SimulationNeedsLayout;
